import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const MultiPartnerService = {
  async getAllRows(filters = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/MultiPartner`, { params: filters });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des conflits multi-partenaires",
      data: [],
    };
  },

  async getConflictDetail(key, personnelId = null) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/MultiPartner/detail`, {
        params: {
          key,
          personnel_id: personnelId || undefined,
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement du detail du conflit",
      data: null,
    };
  },
};

export default MultiPartnerService;
